const patterns = [
  {
    ddi: 55,
    pattern: /^(\+55)(\d{2})(\d{4,5})(\d{4})$/,
    format: "($2) $3-$4",
    postProcess: (phone) => {
      let cleanNumber = phone.replace(/\D/g, "");
      if (
        cleanNumber.length > 10 ||
        !["6", "7", "8", "9"].includes(cleanNumber[2])
      )
        return phone;
      cleanNumber = cleanNumber.slice(0, 2) + "9" + cleanNumber.slice(2);
      return `(${cleanNumber.slice(0, 2)}) ${cleanNumber.slice(
        2,
        7
      )}-${cleanNumber.slice(7)}`;
    },
  },
  { ddi: 1, pattern: /^(\+1)(\d{3})(\d{3})(\d{4})$/, format: "($2) $3-$4" }, // EUA
];

class PhoneParser {
  constructor(number) {
    this.rawNumber = number;
    this.ddi = "";
    this.formattedPhone = "";
    this.processarNumero();
  }

  processarNumero() {
    for (let p of patterns) {
      if (this.rawNumber.match(p.pattern)) {
        this.ddi = p.ddi;
        this.formattedPhone = this.rawNumber.replace(p.pattern, p.format);
        if (p.postProcess) {
          this.formattedPhone = p.postProcess(this.formattedPhone);
          break;
        }
      }
    }
  }

  getDdi() {
    return this.ddi;
  }
  getPhone() {
    return this.formattedPhone;
  }
}

export default PhoneParser;
